import create from 'zustand';

interface ICartSizeState {
  readonly cartIdName: string;
  readonly cartSizeName: string;
  readonly domainName: string;
  readonly cartSize: number;
  readonly setCartIdName: (cartIdName: string) => void;
  readonly setCartSizeName: (cartSizeName: string) => void;
  readonly setDomainName: (domainName: string) => void;
  readonly setCartSize: (cartSize: number) => void;
}

const useCartSizeStore = create<ICartSizeState>((set) => ({
  // default values that can be overwritten in the cms
  cartIdName: '__gbSite__at__cartSize',
  cartSizeName: '__gbSite__at__cart',
  domainName: '.nikon.co.uk',
  cartSize: 0,

  // set cookie names
  setCartIdName: (cartIdName) => set({ cartIdName }),
  setCartSizeName: (cartSizeName) => set({ cartSizeName }),
  setDomainName: (domainName) => set({ domainName }),
  setCartSize: (cartSize) => set({ cartSize }),
}));

export default useCartSizeStore;
